<template>
  <v-container v-show="dataLoaded">
    <v-layout column>
      <v-flex>
        <registration-detail :registration="registration"></registration-detail>
      </v-flex>
      <v-flex>
        <event-detail :event="event" :rink="rink"></event-detail>
      </v-flex>
      <v-flex v-if="trx.length > 0">
        <transaction-detail :trx="trx" :reg-id="registration.id"></transaction-detail>
      </v-flex>
      <v-flex v-if="registration.status === 'pending'">
        <payment-form :registration="registration" :event="event" @submit="makePayment($event)"></payment-form>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="isLoading"
      persistent
      width="200"
    >
    <v-card class="loader">
      <v-card-text>
        <p class="body-1">{{ loadingMessage }}</p>
        <v-progress-circular
          indeterminate
          size="70"
          color="primary">
        </v-progress-circular>
      </v-card-text>
    </v-card>
    </v-dialog>
    <v-dialog
      v-model="isError"
      persistent
      max-width="300"
    >
      <v-card>
        <v-card-title class="headline">
          <v-icon color="red darken-1" >error</v-icon>
          Error
        </v-card-title>
        <v-divider />
        <v-card-text>{{ errorMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="isError = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isSuccess"
      persistent
      max-width="300"
    >
      <v-card>
        <v-card-title class="headline">
          <v-icon color="primary darken-1" >check_circle</v-icon>
          Payment Complete
        </v-card-title>
        <v-divider />
        <v-card-text>{{ successMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="prmiary darken-1" flat @click="isSuccess = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import eventDetail from '../components/receipt/EventDetail'
import registrationDetail from '../components/receipt/RegistrationDetail'
import transactionDetail from '../components/receipt/TransactionDetail'
import paymentForm from '../components/receipt/PaymentForm'
export default {
  name: 'RegistrationReceipt',
  components: {
    eventDetail,
    registrationDetail,
    transactionDetail,
    paymentForm
  },
  data() {
    return {
      dataLoaded: false,
      isLoading: false,
      loadingMessage: '',
      isError: false,
      isSuccess: false,
      successMessage: '',
      errorMessage: '',
      registration: {},
      team: {},
      event: {},
      rink: {},
      trx: []
    }
  },
  computed: {
  },
  methods: {
    makePayment: async function(chargeInfo){
      this.loadingMessage = 'Processing payment...'
      this.isLoading = true
      let paymentResults = await this.$store.dispatch('paySingleRegistration', {...chargeInfo, regId: this.registration.id})
      let transaction = paymentResults.transaction
      let regStatus = Array.isArray(paymentResults.registration_status) ? paymentResults.registration_status : null
      let hasEmailError = false
      let hasPaymentError = false
      let chargeSuccess = true
      if (paymentResults.error) {
        this.isLoading = false
        this.errorMessage = paymentResults.error_detail
        this.isError = true
        return
      }
      if(Array.isArray(regStatus)){
        for(let i = 0; i < regStatus.length; i++) {
          try {
            if(regStatus[i].registration_id === this.registration.id) {
              this.registration.status = regStatus[i].registration_status
            }
          } catch(e) {
            this.errorMessage = e.message
            this.isError = true
          }
          if(regStatus[i].email_error) hasEmailError = true
          if(regStatus[i].charge_success === 0 && regStatus[i].registration_status === 'pending') {
            chargeSuccess = false
            hasPaymentError = true
          }
        }
        if (hasEmailError) {
          this.isLoading = false
          this.errorMessage = 'There was an error sending your confirmation email.'
          this.isError = true
        }
        if (hasPaymentError) {
          this.isLoading = false
          this.errorMessage = 'There was an unknown error processing your payment.'
          this.isError = true
        }
        if (chargeSuccess) {
          this.isLoading = false
          this.trx.push(transaction)
          this.successMessage = 'You\'re payment has been processed and completed. You will recieve a confirmation email momentarily.'
          this.isSuccess = true
        }
      }
    }
  },
  mounted: async function() {
    this.loadingMessage = 'Retrieving Registration Information...'
    this.isLoading = true
    let data = await this.$store.dispatch('loadRegistration', this.$route.params.id)
    this.isLoading = false
    if(data.error) {
      this.errorMessage = data.error
      this.isError = true
      return
    }
    this.registration = data.registration
    this.team = data.team
    this.event = data.event
    this.rink = data.rink
    this.trx = data.trx
    this.dataLoaded = true
  }
}
</script>

<style>
h1, h2, h3, h4, h5 {
  font-family: "Motiva Sns W01 X Bd It",MotivaSans-ExtraBoldItalic,GillSans-BoldItalic,HelveticaNeue-BoldItalic,Helvetica-BoldOblique,Arial-BoldItalicMT,sans-serif
}

body .application, .body {
  font-family: "Motiva Sns W01 Regular",MotivaSans-Regular,GillSans,HelveticaNeue,Helvetica,Arial,sans-serif !important;
}
.v-alert {
  padding: .5rem 1rem;
}

.loader {
  width: 200px;
  height: 200px;
  box-shadow: none;
  text-align: center;
  padding-top: 30px;
}

</style>